export const navItems = [
  { id: 'officialLive2d', text: '官方皮套' },
  { id: 'fan-made-live2d', text: '饭制皮套' },
  { id: 'playlist', text: '歌单' },
  { id: 'rules', text: '综合指南' },
  // { id: 'tutorial', text: '教程' },
  { id: 'calculate', text: '计算器合集' },
];